<p-panel>
    <app-reactive-form-builder
      #formbuilder
      (formChanges)="formChanges($event[0], $event[1])"
      (goBack)="goBack()"
      (afterSend)="undefined"
      [form]="form.formFields"
      [serverUrl]="''"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [dropdownsFinalized]="dropdownsFinalized"
      [id]="getModel().id"
      [request]="getType() === FormRequestTypes.EDIT ? fincasApi.fincasPUT : fincasApi.fincasPOST"
      [getRequest]="fincasApi.fincasGET">
    </app-reactive-form-builder>
</p-panel>

@if (showReaImportDialog) {
  <app-rea-import-modal
    [(visible)]="showReaImportDialog"
    [model]="buildReaModalModel()"
    [historicoREA]="historicoREA"
    (imported)="onReaImported($event)">
  </app-rea-import-modal>
}